module.exports = __webpack_public_path__ + "static/media/oouLogo.15c5599e.jpeg";